import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import {
  clearCurrentThreadOnDelete,
  loadTellentAssistantCurrentThread,
} from './tellent-assistant-current-thread.effects';
import {
  TellentAssistantCurrentThreadNamespace,
  TellentAssistantCurrentThreadReducer,
} from './tellent-assistant-current-thread.state';

const effects = { loadTellentAssistantCurrentThread, clearCurrentThreadOnDelete };

export const provideTellentAssistantCurrentThreadEffects = provideEffects(effects);
export const provideTellentAssistantCurrentThreadState = provideState(
  TellentAssistantCurrentThreadNamespace,
  TellentAssistantCurrentThreadReducer,
);

export const provideTellentAssistantCurrentThreadNgrx = [
  provideTellentAssistantCurrentThreadEffects,
  provideTellentAssistantCurrentThreadState,
];

@NgModule({
  imports: [
    StoreModule.forFeature(
      TellentAssistantCurrentThreadNamespace,
      TellentAssistantCurrentThreadReducer,
    ),
    EffectsModule.forFeature(effects),
  ],
})
export class TellentAssistantCurrentThreadStoreModule {}
